// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IProductVariation } from "../dto/IProducts";
import { ContentEditableEvent } from "react-simple-wysiwyg";
import { BlockService } from "../../block/service";
import { ErrorToast } from "../../../shared/toasters/toasters";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// eslint-disable-next-line @typescript-eslint/no-redeclare
import Editor from "ckeditor5-custom-build/build/ckeditor";
import _debounce from "lodash/debounce";
import { ContentWordsChart } from "../content/components/ContentWordsChart";
import Select from "react-select";
import { themeSelect } from "../../../shared/components/Select2";
import "../../../ckeditor.css";
// kreiranje variacije

interface ICounts {
  [nameField: string]: {
    words: number;
    characters: number;
  };
}
interface IEditorCounter {
  [key: string]: ICounts;
}
const editorConfigurationCustom = {
  toolbar: {
    items: [
      "undo",
      "redo",
      "findAndReplace",
      "alignment",
      "heading",
      "textPartLanguage",
      "|",
      "bold",
      "italic",
      "underline",
      "link",
      "|",
      "horizontalLine",
      "fontColor",
      "fontBackgroundColor",
      "fontSize",
      "highlight",
      "selectAll",
      "pageBreak",
      "strikethrough",
      "specialCharacters",
      "restrictedEditingException",
      "numberedList",
      "bulletedList",
      "indent",
      "outdent",
      "removeFormat",
      "subscript",
      "superscript",
      "HtmlEmbed",
      "sourceEditing",
      "insertTable",
      "|",
      "glossary-scan",
      // "glossary-ignore",
      "glossary-change",
    ],
    shouldNotGroupWhenFull: true, // optional, to prevent grouping when the toolbar is full
  },
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "tableProperties",
      "tableCellProperties",
      "toggleTableCaption",
    ],
  },
  removePlugins: ["Title", "Markdown"], // remove the title plugin from the editor
};
interface IProductVariationFormProps {
  currentVariation: IProductVariation;
  setCurrentVariation: any;
  changeBlocknHandler: (value: string, blockId: number) => void;
  changeVariationHandler: (
    event: ContentEditableEvent | React.ChangeEvent<HTMLInputElement>
  ) => void;
  certainBlocks: any;
  productStaticts?: any;
  certainBlocksVariation?: any;
  setCertainBlocksVariation?: any;
}

export const ProductVariationForm = ({
  setCurrentVariation,
  currentVariation,
  changeVariationHandler,
  certainBlocks,
  changeBlocknHandler,
  productStaticts = {},
  certainBlocksVariation,
  setCertainBlocksVariation,
}: IProductVariationFormProps) => {
  const { t } = useTranslation();
  const language = "en";
  //set langauge for create variation
  const [allBlocks, setAllBlocks] = useState([] as any);
  const [activeBlocks, setActiveBlocks] = useState([] as any);

  useEffect(() => {
    BlockService.getAllBlocks({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setAllBlocks(data as any);
      })
      .catch((error) => ErrorToast(error));
  }, []);

  const [wordCount, setWordCount] = useState<IEditorCounter>();
  const updateWordsCound = _debounce(
    ({ wordsCount, charactersCount, language }, nameField) => {
      setWordCount((prev) => ({
        ...prev,
        [language]: {
          ...prev?.[language],
          [nameField]: {
            ...prev?.[language]?.[nameField],
            words: wordsCount,
            characters: charactersCount,
          },
        },
      }));
    },
    500
  );
  useEffect(() => {
    if (!!allBlocks.length) {
      const currentlyBlocksForProduct = getCertainBlocks(certainBlocks as any);
      setActiveBlocks(currentlyBlocksForProduct);
      setCertainBlocksVariation(certainBlocks);
    }
  }, [allBlocks.length, certainBlocks.length]);

  const getCertainBlocks = (block: number[]) => {
    const data: any[] = [];
    for (let i = 0; i < block?.length; i++) {
      data?.push(allBlocks?.find((el: { id: number }) => el?.id === block[i]));
    }
    return data;
  };
  const changeHandlerEditor = (value: string, eventName: string) => {
    setCurrentVariation((prev: any) => ({ ...prev, [eventName]: value }));
  };
  const handleSelectBlock = (
    selectedValue: MultiValue<{ label: string; value: number; isAdd: boolean }>
  ) => {
    const selectedValues: number[] = [];
    selectedValue.forEach((value) => selectedValues.push(value.value));
    setCertainBlocksVariation(selectedValues);
    const currentlyBlocksForProduct = getCertainBlocks(selectedValues as any);
    setActiveBlocks(currentlyBlocksForProduct);
  };

  return (
    <div className="row gy-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="ck ck-word-count d-flex flex-column justify-content-end">
          <div
            className="ck-word-count__words"
            style={{
              minWidth: "120px",
              marginTop: `${
                !productStaticts?.contentRequirements?.[language]?.["total"]
                  ?.wordCountHigh > 0 && "18px"
              }`,
            }}
          >
            <span className="fw-bold">
              {t("global.all_words")}:{" "}
              {/* {wordCount?.[language]?.["description"]?.words +
                wordCount?.[language]?.["introText"]?.words +
                wordCount?.[language]?.["bullets"]?.words} */}
              {wordCount?.[language] &&
                Object.values(wordCount?.[language])
                  ?.map((item) => item?.words)
                  ?.reduce(
                    (accumulator, currentValue) => accumulator + currentValue
                  )}
            </span>
          </div>
          <div
            className="ck-word-count__characters"
            style={{ minWidth: "120px" }}
          >
            <span className="fw-bold">
              {t("global.all_characters")}:{" "}
              {/* {wordCount?.[language]?.["description"]?.characters +
                wordCount?.[language]?.["introText"]?.characters +
                wordCount?.[language]?.["bullets"]?.characters} */}
              {wordCount?.[language] &&
                Object.values(wordCount?.[language])
                  ?.map((item) => item?.characters)
                  ?.reduce(
                    (accumulator, currentValue) => accumulator + currentValue
                  )}
            </span>
          </div>
        </div>
        <div>
          {productStaticts?.contentRequirements?.[language]?.["total"]
            ?.wordCountHigh > 0 && (
            <ContentWordsChart
              words={
                wordCount?.[language] &&
                Object.values(wordCount?.[language])
                  ?.map((item) => item?.words)
                  ?.reduce(
                    (accumulator, currentValue) => accumulator + currentValue
                  )
              }
              medium={
                productStaticts?.contentRequirements?.[language]?.["total"]
                  ?.wordCountMedium
              }
              high={
                productStaticts?.contentRequirements?.[language]?.["total"]
                  ?.wordCountHigh
              }
            />
          )}
        </div>
      </div>
      <div className="col-md-6">
        <label htmlFor="title" className="required-field">
          {t("products.title")}
        </label>
        <input
          type="text"
          className="form-control"
          name="title"
          onChange={changeVariationHandler}
          value={currentVariation?.title ?? null}
          placeholder={t("products.enter_title")}
        />
      </div>

      <div className="col-12 ">
        <label htmlFor="introText">{t("products.description")}</label>
        {/* {currentVariation && (
          <> */}
        <CKEditor
          config={editorConfigurationCustom}
          editor={Editor}
          data={currentVariation?.description ?? ""}
          onReady={(editor) => {
            editor.ui.view.element.setAttribute(
              "id",
              String(Math.random().toString(16).slice(2))
            );
            const wordsCount = editor.plugins.get("WordCount").words;
            const charactersCount = editor.plugins.get("WordCount").characters;
            setWordCount((prev) => ({
              ...prev,
              [language]: {
                ...prev?.[language],
                description: {
                  ...prev?.[language]?.["description"],
                  words: wordsCount,
                  characters: charactersCount,
                },
              },
            }));
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            changeHandlerEditor(data, "description");
            const wordsCount = editor.plugins.get("WordCount").words;
            const charactersCount = editor.plugins.get("WordCount").characters;
            updateWordsCound(
              {
                wordsCount,
                charactersCount,
                language,
              },
              "description"
            );
          }}
        />
        {/* <div className="d-flex justify-content-start text-align-center mt-3">
          <div className="ck ck-word-count">
            <div className="ck-word-count__words">
              {t("global.words")}:{" "}
              {wordCount?.[language]?.["description"]?.words}
            </div>
            <div className="ck-word-count__characters">
              {t("global.characters")}:{" "}
              {wordCount?.[language]?.["description"]?.characters}
            </div>
          </div>
        </div> */}
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div className="ck ck-word-count">
            <div className="ck-word-count__words">
              {t("global.words")}:{" "}
              {wordCount?.[language]?.["description"]?.words}
            </div>
            <div className="ck-word-count__characters">
              {t("global.characters")}:{" "}
              {wordCount?.[language]?.["description"]?.characters}
            </div>
          </div>
          <div>
            {productStaticts?.contentRequirements?.[language]?.["description"]
              ?.wordCountHigh > 0 && (
              <ContentWordsChart
                words={wordCount?.[language]?.["description"]?.words}
                medium={
                  productStaticts?.contentRequirements?.[language]?.[
                    "description"
                  ]?.wordCountMedium
                }
                high={
                  productStaticts?.contentRequirements?.[language]?.[
                    "description"
                  ]?.wordCountHigh
                }
              />
            )}
          </div>
        </div>
        {/* </>
        )} */}
      </div>
      <div className="col-12 ">
        <label htmlFor="introText">{t("products.introText")}</label>
        {/* {currentVariation && (
          <> */}
        <CKEditor
          config={editorConfigurationCustom}
          editor={Editor}
          data={currentVariation?.introText ?? ""}
          onReady={(editor) => {
            editor.ui.view.element.setAttribute(
              "id",
              String(Math.random().toString(16).slice(2))
            );
            const wordsCount = editor.plugins.get("WordCount").words;
            const charactersCount = editor.plugins.get("WordCount").characters;
            setWordCount((prev) => ({
              ...prev,
              [language]: {
                ...prev?.[language],
                introText: {
                  ...prev?.[language]?.["introText"],
                  words: wordsCount,
                  characters: charactersCount,
                },
              },
            }));
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            changeHandlerEditor(data, "introText");
            const wordsCount = editor.plugins.get("WordCount").words;
            const charactersCount = editor.plugins.get("WordCount").characters;
            updateWordsCound(
              {
                wordsCount,
                charactersCount,
                language,
              },
              "introText"
            );
          }}
        />
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div className="ck ck-word-count">
            <div className="ck-word-count__words">
              {t("global.words")}: {wordCount?.[language]?.["introText"]?.words}
            </div>
            <div className="ck-word-count__characters">
              {t("global.characters")}:{" "}
              {wordCount?.[language]?.["introText"]?.characters}
            </div>
          </div>
          <div>
            {productStaticts?.contentRequirements?.[language]?.["introText"]
              ?.wordCountHigh > 0 && (
              <ContentWordsChart
                words={wordCount?.[language]?.["introText"]?.words}
                medium={
                  productStaticts?.contentRequirements?.[language]?.[
                    "introText"
                  ]?.wordCountMedium
                }
                high={
                  productStaticts?.contentRequirements?.[language]?.[
                    "introText"
                  ]?.wordCountHigh
                }
              />
            )}
          </div>
        </div>
        {/* </>
        )} */}
      </div>
      <div className="col-12 ">
        <label htmlFor="bullets">{t("products.bullets")}</label>
        {/* {currentVariation && (
          <> */}
        <CKEditor
          // config={{ removePlugins: ["Title"] }}
          config={editorConfigurationCustom}
          editor={Editor}
          data={currentVariation?.bullets ?? ""}
          onReady={(editor) => {
            editor.ui.view.element.setAttribute(
              "id",
              String(Math.random().toString(16).slice(2))
            );
            const wordsCount = editor.plugins.get("WordCount").words;
            const charactersCount = editor.plugins.get("WordCount").characters;
            setWordCount((prev) => ({
              ...prev,
              [language]: {
                ...prev?.[language],
                bullets: {
                  ...prev?.[language]?.["bullets"],
                  words: wordsCount,
                  characters: charactersCount,
                },
              },
            }));
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            changeHandlerEditor(data, "bullets");
            const wordsCount = editor.plugins.get("WordCount").words;
            const charactersCount = editor.plugins.get("WordCount").characters;
            updateWordsCound(
              {
                wordsCount,
                charactersCount,
                language,
              },
              "bullets"
            );
          }}
        />
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div className="ck ck-word-count">
            <div className="ck-word-count__words">
              {t("global.words")}: {wordCount?.[language]?.["bullets"]?.words}
            </div>
            <div className="ck-word-count__characters">
              {t("global.characters")}:{" "}
              {wordCount?.[language]?.["bullets"]?.characters}
            </div>
          </div>
          <div>
            {productStaticts?.contentRequirements?.[language]?.["bullets"]
              ?.wordCountHigh > 0 && (
              <ContentWordsChart
                words={wordCount?.[language]?.["bullets"]?.words}
                medium={
                  productStaticts?.contentRequirements?.[language]?.["bullets"]
                    ?.wordCountMedium
                }
                high={
                  productStaticts?.contentRequirements?.[language]?.["bullets"]
                    ?.wordCountHigh
                }
              />
            )}
          </div>
        </div>
        {/* </>
        )} */}
      </div>
      {!!activeBlocks?.length &&
        activeBlocks?.map((block: any) => (
          <div className="col-12" key={block?.id}>
            <label htmlFor="value">{block.name}</label>
            {/* {currentVariation && (
              <> */}
            <CKEditor
              config={{ removePlugins: ["Title", "Markdown"] }}
              // config={editorConfigurationCustom}
              editor={Editor}
              data={currentVariation?.blocks?.[block?.id] ?? ""}
              onReady={(editor) => {
                editor.ui.view.element.setAttribute(
                  "id",
                  String(Math.random().toString(16).slice(2))
                );
                const wordsCount = editor.plugins.get("WordCount").words;
                const charactersCount =
                  editor.plugins.get("WordCount").characters;
                setWordCount((prev) => ({
                  ...prev,
                  [language]: {
                    ...prev?.[language],
                    [block.name]: {
                      ...prev?.[language]?.[block.name],
                      words: wordsCount,
                      characters: charactersCount,
                    },
                  },
                }));
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                changeBlocknHandler(data, block?.id);
                const wordsCount = editor.plugins.get("WordCount").words;
                const charactersCount =
                  editor.plugins.get("WordCount").characters;
                updateWordsCound(
                  {
                    wordsCount,
                    charactersCount,
                    language,
                  },
                  block.name
                );
              }}
            />
            <div className="d-flex justify-content-start text-align-center mt-3">
              <div className="ck ck-word-count">
                <div className="ck-word-count__words">
                  {t("global.words")}:{" "}
                  {wordCount?.[language]?.[block.name]?.words}
                </div>
                <div className="ck-word-count__characters">
                  {t("global.characters")}:{" "}
                  {wordCount?.[language]?.[block.name]?.characters}
                </div>
              </div>
            </div>
          </div>
        ))}
      <>
        {!!allBlocks?.length && (
          <div className="col-md-12 my-3">
            <label htmlFor="blocks">{t("products.blocks")}</label>
            <Select
              // isDisabled={firstView || !accessUserClientDashboard()}
              className="react-select-field"
              theme={themeSelect}
              value={allBlocks
                ?.filter((block) => certainBlocksVariation?.includes(block?.id))
                ?.map((certainValue: { name: string; id: number }) => ({
                  label: certainValue?.name,
                  value: certainValue?.id,
                }))}
              options={allBlocks?.map(
                (value: { name: string; id: number }) => ({
                  label: value?.name,
                  value: value?.id,
                })
              )}
              isMulti
              onChange={(e) => {
                handleSelectBlock(
                  e as MultiValue<{
                    label: string;
                    value: number;
                    isAdd: boolean;
                  }>
                );
              }}
              // key={currentProduct?.id}
            />
          </div>
        )}
      </>
    </div>
  );
};

export default ProductVariationForm;
